import type { RequestFn } from '../http';
import type {
  ExternalTool,
  ExternalToolListResponse,
  AdminExternalToolListResponse,
  ProposeExternalToolData,
  UpdateExternalToolData,
  ReviewExternalToolData,
} from '../types';

export function createExternalToolsApi(request: RequestFn) {
  return {
    async getExternalTools() {
      return request<ExternalToolListResponse>('/tools');
    },

    async proposeExternalTool(data: ProposeExternalToolData) {
      return request<{ tool: ExternalTool }>('/tools/propose', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async getMyExternalToolProposals() {
      return request<{ tools: ExternalTool[] }>('/tools/my-proposals');
    },

    async trackExternalToolClick(id: string) {
      return request<void>(`/tools/${id}/click`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
    },

    async getAdminExternalTools(status?: 'PROPOSED' | 'APPROVED' | 'ARCHIVED') {
      const query = status ? `?status=${encodeURIComponent(status)}` : '';
      return request<AdminExternalToolListResponse>(`/admin/tools${query}`);
    },

    async createExternalToolAsAdmin(data: ProposeExternalToolData) {
      return request<{ tool: ExternalTool }>('/admin/tools', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async updateExternalTool(id: string, data: UpdateExternalToolData) {
      return request<{ tool: ExternalTool }>(`/admin/tools/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },

    async reviewExternalTool(id: string, data: ReviewExternalToolData) {
      return request<{ tool: ExternalTool }>(`/admin/tools/${id}/review`, {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },

    async deleteExternalTool(id: string) {
      return request<void>(`/admin/tools/${id}`, {
        method: 'DELETE',
      });
    },
  };
}
